import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import DatePickerMui from '../../../common/DatePickerMui'; // Adjust path as needed
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DashBoardTable from '../components/Table';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery } from '../../../components/Control/useQuery';
import GetAppIcon from '@material-ui/icons/GetApp';
import { generateExcel } from './CommonExcelGenerator';
import { endpointMapping } from '../helpers/endpointMapping';

const useStyles = makeStyles({
  container: {
    marginTop: 0,
    padding: '18.4px'
  },
  datePickerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '16px'
  },
  exportButton: {
    marginLeft: '16px'
  }
});

const CombinedTableComponent = () => {
  const classes = useStyles();
  const urlParams = new URLSearchParams(window.location.search);
  const dateParam = urlParams.get('date');
  let initialDate = dateParam ? moment(decodeURIComponent(dateParam)) : moment();
  
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const endpoint = useQuery('endpoint') || 'pendingReportsRoute';

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(moment(date));
    }
  };

  const formatDateForApi = (date) => {
    return encodeURIComponent(date.toDate().toUTCString());
  };

  const handleExcelExport = () => {
    if (selectedDate) {
      const formattedDate = formatDateForApi(selectedDate);
      const apiEndpoint = `/api/${endpointMapping[endpoint]?.firstLevel || ''}?date=${formattedDate}`;
      generateExcel(selectedDate.format('YYYY-MM-DD'), apiEndpoint);
    }
  };

  const getFormattedDateForTable = () => {
    if (selectedDate) {
      return formatDateForApi(selectedDate);
    }
    return '';
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.datePickerContainer}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePickerMui
            label="Select Date"
            value={selectedDate ? selectedDate.toDate() : null}
            onChange={handleDateChange}
            views={['month', 'year']}
            format="MMMM yyyy"
            openTo="month"
          />
        </MuiPickersUtilsProvider>
        <Tooltip title="Export to Excel">
          <IconButton 
            onClick={handleExcelExport} 
            className={classes.exportButton}
            color="primary"
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <DashBoardTable
        date={getFormattedDateForTable()}
        endpoint={endpoint}
        frozenColumns={1}
      />
    </Box>
  );
};

export default CombinedTableComponent;